import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SquareLoader } from "react-spinners";

import DashboardLayout from "../Dashboard/DashboardLayout";
import AuthContext from "../../contexts/AuthCtx";
import { api } from "../../api/api";

function AdminLayout({ children }) {
  const navigate = useNavigate();
  const { userToken, clearAdmin } = useContext(AuthContext);
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const verifyAdmin = async () => {
      if (!userToken) {
        clearAdmin();
        navigate("/dashboard", { replace: true });
        return;
      }

      try {
        await api.get("admin/getUsers", {
          headers: { Authorization: `Bearer ${userToken}` },
          params: { limit: 1 },
        });
        if (!cancelled) {
          setIsVerified(true);
        }
      } catch (err) {
        clearAdmin();
        if (err.response?.status === 403 || err.response?.status === 401) {
          localStorage.removeItem("bbr_isAdmin");
        }
        navigate("/dashboard", { replace: true });
      }
    };

    verifyAdmin();

    return () => {
      cancelled = true;
    };
  }, [userToken, clearAdmin, navigate]);

  if (!isVerified) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white">
        <SquareLoader size={60} color="#67295F" />
      </div>
    );
  }

  return (
    <DashboardLayout
      onNewLetter={() => navigate("/dashboard")}
      showFeedback={false}
    >
      {children}
    </DashboardLayout>
  );
}

export default AdminLayout;
